<div>
  <div class="rp-header">
    {{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_PROGRAM' | translate }}
  </div>
  <div class="rp-programs-right">
    <mat-chip-list class="rp-programs-chip-list" aria-label="Rp selection">
      <mat-chip *ngFor="let rpProgramId of rpProgramIdsSet"
                [removable]="true"
                (click)="onEdit(rpProgramId)">
        {{ getName(rpProgramId) }}
        <button
          matChipRemove
          *ngIf="allowOverrides && isManuallyCreated(rpProgramId)"
          (click)="onDelete(rpProgramId)">
          <mat-icon>delete</mat-icon>
        </button>
        <button
          *ngIf="allowOverrides"
          matChipRemove
          (click)="onRemove(rpProgramId)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>

    <div *ngIf="allowOverrides" >
      <mat-form-field>
        <mat-select placeholder="{{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_PROGRAM' | translate }}">
          <mat-option *ngFor="let rpProgram of rpPrograms">
            <div class="option-container">
              <p class="item1" (click)="onPicked(rpProgram?.id)">
                {{ getName(rpProgram?.id)}}
              </p>
              <p class="item2">
                <button *ngIf="allowOverrides && isManuallyCreated(rpProgram.id)" (click)="onDelete(rpProgram.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </p>
              <p class="item3">
                <button *ngIf="allowOverrides" (click)="onEdit(rpProgram.id)">
                  <mat-icon>edit</mat-icon>
                </button>
              </p>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon
        *ngIf="allowOverrides"
        mat-icon-button
        matTooltip="{{'MENU.DISHES.NEW.ADD' | translate}}"
        class="size-scale-edit-button"
        (click)="onEdit()">add_box
      </mat-icon>

      <mat-icon
        *ngIf="allowOverrides && canRestore()"
        mat-icon-button
        matTooltip="{{'MENU.DISHES.NEW.ADD' | translate}}"
        class="size-scale-edit-button"
        (click)="restore()">restore
      </mat-icon>
    </div>
  </div>
</div>
